import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import '@mdi/font/css/materialdesignicons.css';
import './assets/styles/common.css';
import VueMeta from 'vue-meta';

Vue.config.productionTip = false

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
